import type { ExperimentConfig } from '../interfaces'
import type { SettingsStore } from './interfaces'

export const getters = {
  isLoading: (state: SettingsStore): SettingsStore['loading'] => state.loading,
  getSettings: (state: SettingsStore): SettingsStore['settings'] => state.settings,
  hasSettings: (state: SettingsStore): boolean => Object.keys(state.settings).length > 0,
  getExperiments: (state: SettingsStore): Record<string, ExperimentConfig> => state.experiments,
  hasExperiments: (state: SettingsStore): boolean => Object.keys(state.experiments).length > 0,
  getConfigVaultUrl: (state: SettingsStore): SettingsStore['configVaultUrl'] => state.configVaultUrl,
}
